import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Element } from "react-scroll";

import Dropdown from "../Dropdown";

const Container = styled.section`
  margin: 100px 0 70px;
  text-align: left;

  @media (max-width: 1023px) {
    margin: 90px 0 60px;
  }

  @media (max-width: 767px) {
    margin: 70px 0 40px;
  }

  > h2 {
    color: black;
    font-size: 2.8rem;
    font-weight: 500;
    margin-bottom: 28px;
    text-transform: uppercase;
  }
`;

function SupportFAQ({ className, selected }) {
  return (
    <Container className={className}>
      <h2>Foire aux questions</h2>
      <Element name="DON">
        <Dropdown
          title="En savoir plus sur le don"
          shouldOpen={selected === "DON"}
        >
          <p>
            Garantissez l’indépendance du Média et réduisez vos impôts en nous
            faisant un don !
          </p>
          <p>
            Afin d’informer chacun quelle que soit sa situation financière et
            géographique, Le Média a fait depuis ses débuts le choix de
            développer une information majoritairement gratuite et sans
            publicité. Cette information a toutefois un coût de production, et
            nous attachons une importance à mettre en place une politique
            salariale qui permette l’épanouissement professionnel des équipes du
            Média.
          </p>
          <p>
            Lorsque vous donnez au Média par J’aime l’Info, vous pouvez
            défiscaliser vos dons à hauteur de 66% si vous êtes un particulier -
            dans la limite de 20% du montant imposable et, 60% pour les
            personnes morales - dans la limite de 0,5% du chiffre d'affaires.
          </p>
          <p>
            <strong style={{ textDecoration: "underline" }}>EXEMPLE :</strong>
            <br />
            Dans le cas d'un don de 10€, cela vous revient donc à 3,40€ après
            défiscalisation, pour un don de 100€ cela vous reviendra à 34€ après
            défiscalisation.
          </p>
          <p>
            Pour donner, rien de plus simple ! Deux possibilités s’offrent à
            vous :
          </p>
          <ul>
            <li>
              Faire un <a href="https://dons.lemediatv.fr">don en ligne</a>.
            </li>
            <li>
              Faire un don par chèque à J’aime l’Info à l’ordre de “J’aime
              l’Info - Le Média” à adresser à : SCIC Le Média, 242 Boulevard
              Voltaire 75011 Paris (10€ de commission ôtée pour traitement).
            </li>
          </ul>
          <p>
            Que votre don soit en ligne ou par chèque, c’est « J’aime l’info »,
            l’association de soutien de la presse en ligne reconnue d’intérêt
            général, qui vous adressera (soit par e-mail, soit par courrier) un
            reçu fiscal au premier trimestre de l’année qui suit celle de votre
            don afin de l’inscrire sur votre déclaration d’impôt annuelle. Pour
            toute question relative à l’édition ou l’envoi de votre rescrit
            fiscal :{" "}
            <a href="mailto:contact@jaimelinfo.fr">contact@jaimelinfo.fr</a>.
          </p>
        </Dropdown>
      </Element>
      <Element name="ABONNEMENT">
        <Dropdown
          title="En savoir plus sur l'abonnement"
          shouldOpen={selected === "ABONNEMENT"}
          name="ABONNEMENT"
        >
          <p>
            Vous êtes amateur·rice du Média et vous souhaitez participer à son
            financement tout en bénéficiant d’une offre éditoriale exclusive
            enrichie ? C’est désormais possible en devenant abonné·e !
          </p>
          <p>
            Accès aux enquêtes écrites, au forum de discussion, aux tournages et
            aux F.A.Q en direct du Média, autant de contenus exclusifs qui sont
            désormais accessibles à nos abonné·e·s.
          </p>
          <p>
            Faîtes d’une pierre deux coups : accéder à de nouveaux contenus
            exclusifs tout en choisissant une formule d’abonnement adaptée à vos
            possibilités et qui aide Le Média à garantir son indépendance
            économique et éditoriale !
          </p>
        </Dropdown>
      </Element>
      <Element name="SCIC">
        <Dropdown
          title="C'est quoi être Socio&nbsp;?"
          shouldOpen={selected === "SCIC"}
        >
          <p>
            En plus de bénéficier de tous les avantages de l’abonnement, les
            Socios sont membres de la SCIC Le Média.
          </p>
          <h2> Une SCIC c’est quoi ?</h2>
          <p>
            Le Média est devenu la première coopérative de presse nationale
            d’information politique et générale ! Ce modèle unique, fruit d’un
            long processus de construction avec notre communauté, permet au
            Média de développer pleinement la dimension sociale de son projet.
            Cette nouvelle Société Coopérative d’Intérêt Collectif (SCIC) offre
            ainsi à toutes les parties prenantes du Média - Socios, salariés,
            volontaires et partenaires - de prendre part à la gouvernance du
            Média et donc de dessiner son avenir pour les années à venir. En
            rupture totale avec le modèle capitaliste, elle garantit une
            répartition égale du pouvoir de vote entre les Socios et les
            travailleurs du Média, selon le principe “1 personne = 1 voix”.
            <br />
            En devenant Socio, vous pourrez donc participer à la vie collective
            et politique du Média lors des Assemblées Générales ou au moyen
            d’outils internes dédiés.
          </p>
          <h2>Pourquoi c’est important pour nous ?</h2>
          <p>
            La création de la SCIC est un pas supplémentaire vers un modèle de
            gouvernance et d’indépendance que Le Média souhaite le plus vertueux
            possible. En plaçant l’engagement et la transparence au coeur du
            projet, nous sommes convaincus que la communauté du Média, déjà
            puissante aujourd’hui, nouera des liens forts avec les équipes afin
            de continuer à inventer un modèle de presse unique, soucieux de
            l’intérêt général et véritable espace démocratique dans une société
            qui en manque de plus en plus. La SCIC Le Média est l’expérience
            d’un modèle unique dans la presse associant, à égalité dans la prise
            de décision les producteurs d’informations et les lecteurs qui
            contribuent.
          </p>
        </Dropdown>
      </Element>
      <Dropdown title="Pourquoi devenir Socio&nbsp;?">
        <p>
          Concrètement, vous pouvez désormais devenir Socios du Média,
          c’est-à-dire sociétaire de la SCIC et ainsi profiter des avantages
          réservés aux membres de la coopérative :
        </p>
        <ul>
          <li>Accès au forum des Socios</li>
          <li>Participation aux tournages des émissions</li>
          <li>
            Accès à l’intégralité de nos contenus, enquêtes et articles compris.
          </li>
          <li>
            Places gratuites à des événements (débats, conférences, spectacles…)
          </li>
          <li>
            Participation à la vie de la coopérative (Assemblées générales,
            élections, débats internes, etc.)
          </li>
        </ul>
        <h2>Combien ça me coûte ?</h2>
        <p>
          Ouvert à tous les abonnés, le sociétariat est ainsi accessible à
          partir de l’achat d’au moins 5 parts sociales lors de l’inscription à
          1€ la part, soit 5€ minimum.
        </p>
        <p>
          La bonne nouvelle ? Notre SCIC est reconnue Entreprise Solidaire de
          Presse d’Information (ESPI). Ce statut engage Le Média à reverser la
          majorité de ses bénéfices dans le développement de ses activités mais
          surtout vous permet de bénéficier d’une réduction d’impôt de 50% sur
          votre achat de parts sociales !
        </p>
        <p>Concrètement,</p>
        <ul>
          <li>
            Si vous achetez 5 parts sociales pour 5€, cela ne vous coûte en
            réalité que 2,50€ !
          </li>
          <li>
            Si vous achetez 10 parts sociales pour 10€, cela ne vous coûte en
            réalité que 5€ !
          </li>
          <li>
            Si vous achetez 50 parts sociales pour 50€, cela ne vous coûte en
            réalité que 25€ !
          </li>
        </ul>
      </Dropdown>
      <Dropdown title="Vous voulez soutenir&nbsp;? Voici le récap des possibilités&nbsp;!">
        <p>
          Je suis amateur·rice du Média et souhaite{" "}
          <strong>devenir abonné·e</strong> pour apporter un soutien pérenne au
          Média.
        </p>
        <p>
          Je suis amateur·rice du Média et souhaite{" "}
          <strong>devenir Socio</strong> pour devenir membre de la coopérative
          Le Média tout en bénéficiant de
          <strong>tous les avantages de l’abonnement</strong>et percevoir{" "}
          <strong>une réduction d’impôt de 50%</strong> sur ma prise de parts
          sociales.
        </p>
        <p>
          <strong>Je suis déjà abonné·e du Média</strong> et souhaite devenir
          Socio, je bénéficie d’une{" "}
          <strong>
            réduction d’impôt de 50% sur ma prise de parts sociales
          </strong>
          .
        </p>
        <p>
          <strong style={{ textDecoration: "underline" }}>EXEMPLE :</strong>
          <br />
          Lucie, auditrice assidue du Média depuis plusieurs mois, souhaite
          devenir Socio pour profiter de tous les contenus exclusifs et pouvoir
          échanger en direct avec l’équipe du Média. Elle s’abonne avec la
          formule à 10€ par mois (120€ par an) et décide d’acheter 20 parts
          sociales. Sa démarche lui coûtera 84€ pour l’abonnement et 10€ pour le
          sociétariat, soit 94€ au lieu de 140€ au total !
        </p>
      </Dropdown>
    </Container>
  );
}

SupportFAQ.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.oneOf(["DON", "ABONNEMENT", "SCIC"]),
};

export default SupportFAQ;
